import React from 'react'

export default function AppDetails() {
	return (
		<div>

		</div>
	)
}
